import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { createTracker } from 'usage-tracker';
import events from 'settings-ui-security/events.yaml';
export const TwoFactorAuthTypes = {
  HUBSPOT_AUTHENTICATOR: 'twoFactorHubSpotAuthenticator',
  THIRD_PARTY_AUTHENTICATOR: 'twoFactorThirdPartyAuthenticator',
  SMS_CODES: 'twoFactorSmsAuthenticator'
};
export const TwoFactorEventActions = {
  INITIATED: 'Initiated',
  DISMISSED: 'Dismissed',
  ACCOMPLISHED: 'Accomplished',
  REMOVED: 'Removed',
  VISIBLE: 'Visible',
  VERIFYING: 'Verifying'
};
export const PasskeyEventActions = {
  INITIATE_PASSKEY_SETUP: 'InitiatePasskeySetup',
  COMPLETE_PASSKEY_SETUP: 'CompletePasskeySetup',
  FAIL_PASSKEY_SETUP: 'FailPasskeySetup',
  DISMISS_PASSKEY_SETUP: 'DismissPasskeySetup',
  LEARN_MORE: 'LearnMore',
  CANCEL_PASSKEY_SETUP: 'CancelPasskeySetup'
};
const baseTracker = createTracker({
  events,
  properties: {
    namespace: 'settings-ui-security'
  },
  allowUnauthed: true,
  debug: true
});
export let tracker = baseTracker;
export const enableHublessTracking = () => {
  return noPortalApiClient.get('/login-verify/user-info')
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'user' does not exist on type 'JSON'.
  .then(({
    user
  }) => user.emails[0]).then(email => {
    tracker = baseTracker.clone({
      properties: {
        hubId: null,
        email
      }
    });
  });
};
export const trackScreen = screen => {
  tracker.track('pageView', {
    screen
  });
};
export const twoFactorAuthNudgeInitiated = () => {
  tracker.track('twoFactorAuthNudge', {
    action: 'Initiated'
  });
};
export const twoFactorAuthNudgeDismissed = () => {
  tracker.track('twoFactorAuthNudge', {
    action: 'Dismissed'
  });
};
export const twoFactorAuthNudgeAccomplished = () => {
  tracker.track('twoFactorAuthNudge', {
    action: 'Accomplished'
  });
};
export const trackTwoFactorSetup = (twoFactorMethod, action) => {
  tracker.track(twoFactorMethod, {
    action
  });
};
export const trackPasskeyNudgeDismissed = () => {
  tracker.track('passkeyNudge', {
    action: PasskeyEventActions.DISMISS_PASSKEY_SETUP
  });
};
export const trackPasskeyNudgeSetupInitiated = () => {
  tracker.track('passkeyNudge', {
    action: PasskeyEventActions.INITIATE_PASSKEY_SETUP
  });
};
export const trackPasskeyNudgeSetupCompleted = () => {
  tracker.track('passkeyNudge', {
    action: PasskeyEventActions.COMPLETE_PASSKEY_SETUP
  });
};
export const trackPasskeyNudgeSetupFailed = () => {
  tracker.track('passkeyNudge', {
    action: PasskeyEventActions.FAIL_PASSKEY_SETUP
  });
};
export const trackPasskeyNudgeUserCancelled = () => {
  tracker.track('passkeyNudge', {
    action: PasskeyEventActions.CANCEL_PASSKEY_SETUP
  });
};
export const trackPasskeyLearnMore = () => {
  tracker.track('passkeyNudge', {
    action: PasskeyEventActions.LEARN_MORE
  });
};
export const trackPasskeySettingsSetupInitiated = () => {
  tracker.track('passkeySettingsActivation', {
    action: PasskeyEventActions.INITIATE_PASSKEY_SETUP
  });
};
export const trackPasskeySettingsSetupCompleted = () => {
  tracker.track('passkeySettingsActivation', {
    action: PasskeyEventActions.COMPLETE_PASSKEY_SETUP
  });
};
export const trackPasskeySettingsSetupFailed = () => {
  tracker.track('passkeySettingsActivation', {
    action: PasskeyEventActions.FAIL_PASSKEY_SETUP
  });
};
export const trackPasskeySettingsUserCancelled = () => {
  tracker.track('passkeySettingsActivation', {
    action: PasskeyEventActions.CANCEL_PASSKEY_SETUP
  });
};